module.exports = __webpack_public_path__ + "img/img_series_112.368d5939.png";